import * as React from 'react';

import styles from './CatalogCategoryMenu.scss';
import { genPublicUrl } from 'libs/image';
import { useCatalogLayoutContext } from 'components/catalogs/layouts/CatalogLayout/CatalogLayout';

const toCatalogCategoryPath = (catalogCode: string, categoryCode: string): string =>
  `/catalogs/${encodeURIComponent(catalogCode)}/categories/${encodeURIComponent(categoryCode)}`;

export const CatalogCategoryMenu = (): JSX.Element | null => {
  const { catalog, categories, hasError } = useCatalogLayoutContext();
  const catalogCode = catalog?.code ?? '';
  const safeCategories = categories ?? [];

  if (hasError || !catalogCode || safeCategories.length === 0) {
    return null;
  }

  return (
    <section className={styles.section}>
      <h2 className={styles.title}>カテゴリから選ぶ</h2>
      <ul className={styles.grid}>
        {safeCategories.map((category) => (
          <li
            key={category.code}
            className={styles.item}
          >
            <a
              className={styles.card}
              href={toCatalogCategoryPath(catalogCode, category.code)}
            >
              <div className={styles.thumb}>
                {category.imageUrl ? (
                  <img
                    className={styles.thumbImage}
                    src={genPublicUrl(category.imageUrl, 640)}
                    alt=""
                    loading="lazy"
                    decoding="async"
                  />
                ) : (
                  <div className={styles.thumbPlaceholder} />
                )}
              </div>
              <div className={styles.name}>{category.name}</div>
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
};
